import { STAGES } from './constants';

// Una etapa se completa cuando todos sus entregables están visibles; sin entregables no bloquea el avance.
export function computeRoute(com = [], fex = []) {
  const inRoute = com.concat(fex).filter((x) => x.stage >= 1 && x.stage <= STAGES.length);
  const stages = STAGES.map((st, i) => {
    const items = inRoute.filter((x) => x.stage === i + 1);
    const done = items.filter((x) => x.visible).length;
    return { ...st, num: i + 1, items, done, total: items.length, complete: items.length > 0 && done === items.length };
  });
  const total = inRoute.length;
  const done = inRoute.filter((x) => x.visible).length;
  const open = (s) => s.total > 0 && !s.complete;
  const firstOpen = stages.findIndex(open);
  const current = firstOpen === -1 ? stages.length - 1 : firstOpen;
  const pct = total ? Math.round((done / total) * 100) : 0;
  const heroText =
    firstOpen === -1
      ? `Tu proyecto está completo: los ${total} entregables ya están disponibles.`
      : `Vas en la etapa ${current + 1} de ${stages.length} (${stages[current].name}) · ${done} de ${total} entregables disponibles`;
  return { stages, total, done, pct, current, firstOpen, heroText, isOpen: open };
}

export function countModule(list = []) {
  const total = list.length;
  const loaded = list.filter((x) => x.hasContent).length;
  const visible = list.filter((x) => x.visible).length;
  return { total, loaded, visible, pct: total ? Math.round((visible / total) * 100) : 0 };
}

export const pad2 = (n) => String(n).padStart(2, '0');

export function timeAgo(iso) {
  if (!iso) return 'disponible';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 'disponible';
  const min = Math.floor((Date.now() - t) / 60000);
  if (min < 1) return 'hace un momento';
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} ${h === 1 ? 'hora' : 'horas'}`;
  return new Date(t).toLocaleDateString('es-CO', { day: 'numeric', month: 'short' });
}

export function formatSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function previewKind(fileName = '', mime = '') {
  const n = fileName.toLowerCase();
  if (mime.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/.test(n)) return 'image';
  if (mime.includes('pdf') || n.endsWith('.pdf')) return 'pdf';
  if (mime.includes('html') || /\.html?$/.test(n)) return 'html';
  return 'doc';
}
